import { useI18n } from "@/context/I18nContext";

const COLORS = {
  BULLISH: { fg: "#0a0a0a", bg: "var(--mq-green)", glow: "rgba(0,255,128,0.45)" },
  BEARISH: { fg: "#fff", bg: "var(--mq-red)", glow: "rgba(255,64,64,0.45)" },
  NEUTRAL: { fg: "var(--mq-text-1)", bg: "transparent", glow: "transparent" },
};

export default function PredictivePill({ predictive }) {
  const { t } = useI18n();
  if (!predictive) return null;
  const label = (predictive.label || "NEUTRAL").toUpperCase();
  const score = predictive.score ?? 0;
  const palette = COLORS[label] || COLORS.NEUTRAL;
  const labelKey = label === "BULLISH" ? "bullish" : label === "BEARISH" ? "bearish" : "neutral";

  return (
    <div
      data-testid="predictive-pill"
      title={`Outlook score ${score.toFixed(2)} · components: ${JSON.stringify(predictive.components || {})}`}
      className="flex flex-col items-end"
    >
      <span className="mq-label">{t("outlook")}</span>
      <span
        data-testid="predictive-pill-label"
        className="mq-metric text-[0.7rem] tracking-widest font-bold px-2 py-0.5 border rounded-full"
        style={{
          background: palette.bg,
          color: palette.fg,
          borderColor: palette.bg === "transparent" ? "var(--mq-border)" : palette.bg,
          boxShadow: label === "NEUTRAL" ? "none" : `0 0 8px ${palette.glow}`,
          minWidth: 78,
          textAlign: "center",
        }}
      >
        {t(labelKey)}
      </span>
    </div>
  );
}
